// removed by extract-text-webpack-plugin
module.exports = {"WelcomeLayoutContainer":"WelcomeLayoutContainer---2hjV2","WelcomeLayout":"WelcomeLayout---dwttv","NavButtons":"NavButtons---3efYg","BreadCrumbContainer":"BreadCrumbContainer---1lGW8","WelcomeLayoutNav":"WelcomeLayoutNav---JCJzf","WelcomePreview":"WelcomePreview---3INBp","WelcomeTitle":"WelcomeTitle---twGU6","WelcomeTip":"WelcomeTip---1XDcs","WelcomeBreadCrumbs":"WelcomeBreadCrumbs---3GFGD","WelcomeContainer":"WelcomeContainer---1YBSi","Welcome":"Welcome---2PUAH","ProfileDetails":"ProfileDetails---7Amdw","Integration":"Integration---2L8S2"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/SlackInstall/style.styl
// module id = +xoI
// module chunks = 89